import { useMutation } from "react-query";
import axios from "axios";
import Config from "../Config";
import { toast } from "react-toastify";

export const usePaymentMutations = (token) => {
    const processPayUTransaction = async (values) => {
        return await axios.post(`${Config.ApiUrl}/hash/web/payment/new`, values, {
            headers: {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
    };

    const processEasebuzzTransaction = async (values) => {
        return await axios.post(`${Config.ApiUrl}/easebuzz/web-payment`, values, {
            headers: {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
    };

    const handlePayUTransactionSuccess = (data) => {
        document.body.insertAdjacentHTML("beforeend", data?.data);
        const payuForm = document.getElementById("payuForm");
        if (payuForm) {
            payuForm.submit();
        }
    };

    const handleEasebuzzTransactionSuccess = (response) => {
        if (response?.data && response?.data?.data?.payment_url) {
            window.location.href = response?.data?.data?.payment_url;
        } else {
            toast.success("Payment initiated successfully!");
        }
    };

    const handleTransactionError = (error) => {
        toast.error(error?.response?.data?.msg || "Payment processing error");
    };

    const { isLoading: isPayUTransactionLoading, mutate: payUTransactionMutate } =
        useMutation(processPayUTransaction, {
            onSuccess: handlePayUTransactionSuccess,
            onError: handleTransactionError,
        });

    const {
        isLoading: isEasebuzzTransactionLoading,
        mutate: easebuzzTransactionMutate,
    } = useMutation(processEasebuzzTransaction, {
        onSuccess: handleEasebuzzTransactionSuccess,
        onError: handleTransactionError,
    });

    return {
        payUTransactionMutate,
        easebuzzTransactionMutate,
        isPayUTransactionLoading,
        isEasebuzzTransactionLoading,
    };
};